import React from "react";
import { Tooltip } from "antd";
import { Link } from "react-router-dom";
import { css } from "glamor";

import { formatWithJsonSchema } from "../../formatters";
import monitoringIcon from "./monitoringIcon.png";

const styles = {
    monitoringIcon: {
        width: 30,
        opacity: 0.5,
    },
    activeMonitoringIcon: {
        opacity: 1,
    },
    tooltipTitle: css({
        fontSize: 13,
        marginBottom: 5,
    }),
    tooltipItem: css({
        fontSize: 11,
    }),
};

const TooltipContent = ({ data, isEnabled }) => (
    <div>
        <div className={styles.tooltipTitle}>
            This request is {isEnabled ? "being" : "not"} monitored
        </div>
        {isEnabled && (
            <div className={styles.tooltipItem}>
                Frequency: {data.pollingFrequency}
            </div>
        )}
    </div>
);

const WrapLink = ({ isEnabled, ulid, children }) => {
    if (isEnabled) {
        return (
            <Link to={`/tickets/${ulid}/continuous_monitoring/`}>
                {children}
            </Link>
        );
    } else {
        return children;
    }
};

const MonitoringIcon = ({ request }) => {
    const monitoringResponse = request.entity.continuousMonitoring;
    const ulid = request.ulid;
    const { jsonSchema_: schema, ...monitoringData } = monitoringResponse;
    const isEnabled = monitoringData.status === "ENABLED";
    const iconStyle = {
        ...styles.monitoringIcon,
        ...(isEnabled && styles.activeMonitoringIcon),
    };
    const formattedData = formatWithJsonSchema({
        jsonSchema: schema,
        data: monitoringData,
    });
    return (
        <WrapLink isEnabled={isEnabled} ulid={ulid}>
            <Tooltip
                placement="left"
                title={
                    <TooltipContent
                        isEnabled={isEnabled}
                        data={formattedData}
                    />
                }
            >
                <img alt="monitoring" src={monitoringIcon} style={iconStyle} />
            </Tooltip>
        </WrapLink>
    );
};

export default MonitoringIcon;
